import { useRef, useMemo, useEffect } from 'react';

export const useTermsAndConditionsLink = (promoData) => {
    const termsLinkRef = useRef(null);

    const termsAndConditionsLink = useMemo(() => {
        const isPromoCodeExists = Boolean(
            promoData &&
            typeof promoData === 'string' &&
            JSON.parse(promoData)?.promoCode,
        );

        if (!isPromoCodeExists) return null;

        return (
            <div className="d-flex pl-4 py-4">
                <a
                    ref={termsLinkRef}
                    className="jos-show-terms-and-conditions priceColor fontSize1X"
                    role="button"
                    tabIndex="0"
                    aria-haspopup="dialog"
                    aria-expanded="false"
                    data-promo={promoData}
                >
                    * See details and exclusions
                </a>
            </div >
        );
    }, [promoData]);

    useEffect(() => {
        if (termsLinkRef.current && window?.josTermsAndCondition) {
            window.josTermsAndCondition?.showTriggerLinks();
        }
    }, [termsAndConditionsLink]);

    return termsAndConditionsLink;
};